import useBedbankDiscount from 'hooks/useBedbankDiscount'
import useBedbankOfferSearchPricing from 'hooks/useBedbankOfferSearchPricing'
import { EmptyObject } from 'lib/object/objectUtils'
import { getHotelOfferUrl } from 'lib/offer/offerPageURL'
import React, { useMemo } from 'react'
import SearchTileWalledMessage from '../shared/SearchTileWalledMessage'
import BedbankSearchTileWalledContent from './BedbankSearchTileWalledContent'
import { useDirectSearchPrices } from 'hooks/Search/useSearchPrices'
import BedbankMetaSearchTileGarden from './BedbankMetaSearchTileGarden'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  filters?: App.OfferListFilters
  hidePrice?: boolean
}

function BedbankMetaSearchTilePriceStack({
  offer,
  filters = EmptyObject,
  hidePrice = false,
}: Props) {
  const {
    bundlePrice,
    bundlePropertyFees,
    bundleTaxesAndFees,
    discountPercentage,
    displayMargin,
    flightPrice,
    hotelNights,
    hotelPrice,
    hotelRate,
    isFlexibleSearch,
    margin,
    marginAud,
    nightsToDisplay,
    offerPrice,
    promoteAsBundle,
    propertyFees,
    rooms,
    saleUnit,
    shownRate,
    suggestedDates,
    supplier,
    taxesAndFees,
    value,
  } = useBedbankOfferSearchPricing(offer, filters)

  const offerLocations: Array<string> = useMemo(() => {
    const locations = [
      offer.property?.address.city,
      offer.property?.address.stateProvinceName || '',
      offer.property?.address.countryName]
      .filter(Boolean)

    return locations
  }, [offer])

  const offerUrl = useMemo(() => getHotelOfferUrl(offer.id, offer.type), [offer])

  const discount = useBedbankDiscount(hotelRate?.discount, hotelRate?.memberDiscount)

  const directSearchPrices = useDirectSearchPrices({ filters, offerId: offer.id })

  return <BedbankSearchTileWalledContent
    wall={<SearchTileWalledMessage discountPercentage={discount} />}
    offer={offer}
    hidePricing={offer.hidePricing}
    filters={filters}
  >
    <BedbankMetaSearchTileGarden
      offer={offer}
      offerPrice={offerPrice}
      isFlexibleSearch={isFlexibleSearch}
      suggestedDates={suggestedDates}
      nightsToDisplay={nightsToDisplay}
      promoteAsBundle={promoteAsBundle}
      saleUnit={saleUnit}
      rooms={rooms}
      discountPercentage={discountPercentage}
      value={value}
      hotelNights={hotelNights}
      offerLocations={offerLocations}
      displayMargin={displayMargin}
      margin={margin}
      marginAud={marginAud}
      supplier={supplier}
      directSearchPrices={directSearchPrices}
      shownRate={shownRate}
      bundlePropertyFees={bundlePropertyFees}
      propertyFees={propertyFees}
      bundleTaxesAndFees={bundleTaxesAndFees}
      taxesAndFees={taxesAndFees}
      bundlePrice={bundlePrice}
      hotelPrice={hotelPrice}
      flightPrice={flightPrice}
      offerUrl={offerUrl}
      hidePrice={hidePrice}
    />
  </BedbankSearchTileWalledContent>
}

export default BedbankMetaSearchTilePriceStack
